import {APIStatusType} from '@web/core/constants'

export const RewardPoint = {
    REWARD: 'REWARD',
    CASH_REWARD: 'CASH_REWARD',
} as const

export type RewardPointType = Constant<typeof RewardPoint>

export const CashableReward = {
    NORMAL: 'NORMAL',
    VOUCHER: 'VOUCHER',
} as const

export type CashableRewardType = Constant<typeof CashableReward>

/** 포인트 상세정보 */
export interface SubDetail {
    /** 포인트 하위구분 이름 */
    text: Maybe<string>
    /** 포인트 하위구분의 잔액 */
    balance: Maybe<number>
}

export interface PointDescription {
    /** 적립타입 */
    type: RewardPointType
    /** CASH_REWARD의 하위 적립타입 */
    cashType: Maybe<CashableRewardType>
    /** 포인트 명 */
    text: Maybe<string>
    /** 포인트 잔액 */
    balance: number
    /** 로고 이미지의 URL */
    logoImageUrl?: string
    /** 포인트의 상세정보 */
    subDetails?: SubDetail[]
}

export interface RewardPointState {
    /** 적립 포인트 조회 상태 */
    status: APIStatusType
    /** 적립포인트 총액(현금성 포함) */
    amount: number
    /** 총액 내 현금성 적립포인트 잔액 */
    cashPoint: number
    /** 적립 포인트 조회 실패 */
    maintenanceInfo: Maybe<MaintenanceInfo>
    /** 적립포인트 상세정보 */
    descriptions: PointDescription[]
}

export type RootState = {rewardPoint: RewardPointState}

type MaintenanceInfo = {
    startDate: string
    endDate: string
    noticeMessage: string
}
